import { render, staticRenderFns } from "./blogrelatedcontent.componet.vue?vue&type=template&id=0562cbc0&scoped=true"
import script from "./blogrelatedcontent.componet.vue?vue&type=script&lang=js"
export * from "./blogrelatedcontent.componet.vue?vue&type=script&lang=js"
import style0 from "./blogrelatedcontent.componet.vue?vue&type=style&index=0&id=0562cbc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0562cbc0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VChip,VCol,VDataTable,VImg,VRow,VSwitch,VTextField})
